<div class="row" *ngIf="pricatData">
  <div class="header-title col-12">
    <div>
      <h3>
        {{ 'PRICAT' | translate }}: {{ pricatData.id }}
        <span style="float: right">
          <lib-edi-send-status [message]="pricatData"></lib-edi-send-status>
        </span>
      </h3>
    </div>
  </div>
  <div class="col-12">
    <lib-action-btn class="float-right mb-2" [(item)]="pricatData" [config]="actionConfigService"></lib-action-btn>
  </div>
  <div class="col-lg-7">
    <div class="row pt-4">
      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label" translate>CONFIG_ID</label>
          <input class="form-control" type="text" [ngModel]="pricatData?.ediConfigId" [disabled]="true" />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label" translate>BUYER_GLN</label>
          <input class="form-control" type="text" [ngModel]="pricatData?.buyerGln" [disabled]="true" />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label" translate>VALIDATION</label>
          <input class="form-control" type="text" [ngModel]="pricatData?.validationState" [disabled]="true" />
        </div>
      </div>
      <div class="col-md-4" *ngIf="!!pricatData.timestamp">
        <div class="form-group">
          <label class="control-label" translate>TIMESTAMP</label>
          <input class="form-control" type="text" [ngModel]="pricatData?.timestamp" [disabled]="true" />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label" translate>GUNG_EDI_MESSAGE_SEND_STATUS</label>
          <input class="form-control" type="text" [ngModel]="pricatData?.gungEdiMessageSendStatus" [disabled]="true" />
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-5">
    <lib-edi-gln-number-tabs [ediMessage]="pricatData"></lib-edi-gln-number-tabs>
  </div>

  <div class="col-12" *ngIf="pricatData.items?.length > 0 && itemsColumns.length > 0">
    <h3>{{ 'LINES' | translate }}</h3>
    <lib-edi-row-table [data]="pricatData.items" [columns]="itemsColumns"></lib-edi-row-table>
  </div>
</div>
